const video = document.querySelector('.video-controll__video video');
const btn = document.querySelector('.video-controll__btn');

if (video && btn) {
  const reducedMotionQuery = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const playIcon = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M17.0215 27.9211V15.0784C17.0218 14.9177 17.0652 14.7601 17.1474 14.622C17.2295 14.4839 17.3473 14.3704 17.4883 14.2935C17.6294 14.2165 17.7886 14.1789 17.9492 14.1846C18.1097 14.1904 18.2658 14.2392 18.4011 14.3259L28.3914 20.7455C28.5179 20.8265 28.622 20.9381 28.6941 21.0699C28.7662 21.2017 28.804 21.3495 28.804 21.4998C28.804 21.65 28.7662 21.7978 28.6941 21.9296C28.622 22.0614 28.5179 22.173 28.3914 22.254L18.4011 28.6754C18.2658 28.7622 18.1097 28.811 17.9492 28.8167C17.7886 28.8224 17.6294 28.7848 17.4883 28.7078C17.3473 28.6309 17.2295 28.5174 17.1474 28.3793C17.0652 28.2412 17.0218 28.0836 17.0215 27.9229V27.9211Z" fill="white" fill-opacity="0.5"/>
      <path d="M1.79102 21.4998C1.79102 10.6155 10.615 1.7915 21.4993 1.7915C32.3837 1.7915 41.2077 10.6155 41.2077 21.4998C41.2077 32.3842 32.3837 41.2082 21.4993 41.2082C10.615 41.2082 1.79102 32.3842 1.79102 21.4998ZM21.4993 4.479C16.9851 4.479 12.6558 6.27226 9.4638 9.46429C6.27178 12.6563 4.47852 16.9856 4.47852 21.4998C4.47852 26.014 6.27178 30.3434 9.4638 33.5354C12.6558 36.7274 16.9851 38.5207 21.4993 38.5207C26.0136 38.5207 30.3429 36.7274 33.5349 33.5354C36.7269 30.3434 38.5202 26.014 38.5202 21.4998C38.5202 16.9856 36.7269 12.6563 33.5349 9.46429C30.3429 6.27226 26.0136 4.479 21.4993 4.479Z" fill="white" fill-opacity="0.5"/>
    </svg>
  `;

  const pauseIcon = `
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M18.8125 13.4375H16.125V29.5625H18.8125V13.4375ZM26.875 13.4375H24.1875V29.5625H26.875V13.4375Z" fill="white" fill-opacity="0.5"/>
      <path d="M21.5 5.375C24.6892 5.375 27.8068 6.32071 30.4586 8.09255C33.1103 9.86439 35.1771 12.3828 36.3976 15.3292C37.618 18.2757 37.9374 21.5179 37.3152 24.6458C36.693 27.7738 35.1572 30.647 32.9021 32.9021C30.647 35.1572 27.7738 36.693 24.6458 37.3152C21.5179 37.9373 18.2757 37.618 15.3292 36.3976C12.3828 35.1771 9.8644 33.1103 8.09256 30.4586C6.32072 27.8068 5.37501 24.6892 5.37501 21.5C5.37501 17.2234 7.07389 13.1219 10.0979 10.0979C13.1219 7.07388 17.2234 5.375 21.5 5.375ZM21.5 2.6875C17.7792 2.6875 14.142 3.79083 11.0483 5.85798C7.95464 7.92512 5.5434 10.8632 4.11952 14.3008C2.69565 17.7383 2.3231 21.5209 3.04899 25.1701C3.77487 28.8194 5.56659 32.1715 8.19756 34.8024C10.8285 37.4334 14.1806 39.2251 17.8299 39.951C21.4791 40.6769 25.2617 40.3044 28.6992 38.8805C32.1368 37.4566 35.0749 35.0454 37.142 31.9517C39.2092 28.858 40.3125 25.2208 40.3125 21.5C40.3125 16.5106 38.3305 11.7256 34.8025 8.19755C31.2744 4.66953 26.4894 2.6875 21.5 2.6875Z" fill="white" fill-opacity="0.5"/>
    </svg>
  `;

  function updateControl() {
    if (video.paused) {
      btn.setAttribute('data-state', 'pause');
      btn.setAttribute('aria-label', 'Play video');
      btn.innerHTML = playIcon;
    } else {
      btn.setAttribute('data-state', 'play');
      btn.setAttribute('aria-label', 'Pause video');
      btn.innerHTML = pauseIcon;
    }
  }

  function toggleVideo() {
    if (video.paused) {
      video.play().catch(() => {
        updateControl();
      });
    } else {
      video.pause();
    }
  }

  function applyReducedMotion() {
    if (reducedMotionQuery.matches) {
      video.pause();
    }

    updateControl();
  }

  btn.addEventListener('click', toggleVideo);

  video.addEventListener('play', updateControl);
  video.addEventListener('pause', updateControl);

  if (reducedMotionQuery.addEventListener) {
    reducedMotionQuery.addEventListener(
      'change',
      applyReducedMotion
    );
  } else {
    reducedMotionQuery.addListener(
      applyReducedMotion
    );
  }

  applyReducedMotion();
}